import { render, staticRenderFns } from "./key-info.vue?vue&type=template&id=836582b0&scoped=true"
import script from "./key-info.vue?vue&type=script&lang=js"
export * from "./key-info.vue?vue&type=script&lang=js"
import style0 from "./key-info.vue?vue&type=style&index=0&id=836582b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836582b0",
  null
  
)

export default component.exports